module.exports = __webpack_public_path__ + "static/img/19.60d655d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/19.png
// module id = xVMQ
// module chunks = 0